import { connect } from 'react-redux';

import { PROPERTY_TYPE_SUBJECT } from 'legacy/appstore/constants';

import { photosDialogShow } from 'actions/photos';

import {
  getSubjectIsActiveListing,
  getSubjectAdjusted
} from 'selectors/subject';

import SubjectPhotoCard from 'legacy/components/SubjectPhotoCard';

const mapStateToProps = (state, ownProps) => {
  const subject = getSubjectAdjusted(state);
  return {
    activePrice: getSubjectIsActiveListing(state) && subject.lastListPrice,
    addressId: subject.addressId,
    subject
  };
};
const mapDispatchToProps = (dispatch) => ({
  onClick: (addressId) => {
    dispatch(
      photosDialogShow(addressId, {
        propertyType: PROPERTY_TYPE_SUBJECT,
        currentIndex: 0
      })
    );
  }
});

const mergeProps = (stateProps, dispatchProps, ownProps) => {
  return {
    ...stateProps,
    ...dispatchProps,
    ...ownProps,
    onClick: () => dispatchProps.onClick(stateProps.addressId)
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps,
  mergeProps
)(SubjectPhotoCard);
